export const PRODUCT_SEARCH_OFFERS_QUERY = `
  query GetProductSearchOffers(
    $from: String!
    $to: String!
    $mandant: String!
    $profile: String!
    $channel: String!
    $country: String
    $categories: String
    $price: String
    $stars: Int
    $duration: String
    $roomType: String
    $mealType: String
    $departureAirports: String
    $tourOperator: String
    $transfer: Int
    $rentalCar: Int
    $railAndFly: Int
    $minRecom: Float
    $directFlight: Boolean
    $searchId: String
    $subsource: String
    $room: String
    $utmCampaign: String
    $specialDealTypes: [SpecialDealTypes]
    $dateExact: Int
    $platformName: String
    $userId: String
    $device: String
    $app: Boolean
    $travellers: String
    $groupBy: GroupByTypes
    $cids: String
  ) {
    getProductSearchOffers(
      cids: $cids
      from: $from
      to: $to
      mandant: $mandant
      profile: $profile
      channel: $channel
      country: $country
      categories: $categories
      price: $price
      stars: $stars
      duration: $duration
      roomType: $roomType
      mealType: $mealType
      departureAirports: $departureAirports
      tourOperator: $tourOperator
      transfer: $transfer
      rentalCar: $rentalCar
      railAndFly: $railAndFly
      minRecom: $minRecom
      directFlight: $directFlight
      searchId: $searchId
      subsource: $subsource
      room: $room
      utmCampaign: $utmCampaign
      specialDealTypes: $specialDealTypes
      dateExact: $dateExact
      platformName: $platformName
      userId: $userId
      device: $device
      app: $app
      travellers: $travellers
      groupBy: $groupBy
    ) {
      comvelProductVariantResponse {
        airlines {
          iataCode
          name
        }
      }
    }
  }
`;
